module.exports = __webpack_public_path__ + "img/gup.c4770df8.svg";